var exports = {
  "tb": "UserProfileModal.module__noteTextarea___Uk1XeU",
  "CR": "UserProfileModal.module__modalRoot___Uk1XeU",
  "eF": "UserProfileModal.module__userInfo___Uk1XeU",
  "hR": "UserProfileModal.module__userInfoHeader___Uk1XeU",
  "hA": "UserProfileModal.module__userInfoHeaderDesktop___Uk1XeU",
  "Rn": "UserProfileModal.module__userInfoContent___Uk1XeU",
  "yn": "UserProfileModal.module__profileDataWarning___Uk1XeU",
  "S7": "UserProfileModal.module__nameRow___Uk1XeU",
  "nT": "UserProfileModal.module__userName___Uk1XeU",
  "a1": "UserProfileModal.module__userTag___Uk1XeU",
  "Fj": "UserProfileModal.module__usernameRow___Uk1XeU",
  "hI": "UserProfileModal.module__pronouns___Uk1XeU",
  "sM": "UserProfileModal.module__srOnly___Uk1XeU",
  "Li": "UserProfileModal.module__customStatusText___Uk1XeU",
  "Ef": "UserProfileModal.module__customStatusRow___Uk1XeU",
  "_z": "UserProfileModal.module__tagBadgeRow___Uk1XeU",
  "U3": "UserProfileModal.module__badgesWrapper___Uk1XeU",
  "ZV": "UserProfileModal.module__userNoteEditor___Uk1XeU",
  "xu": "UserProfileModal.module__noteLabel___Uk1XeU",
  "_j": "UserProfileModal.module__noteTextareaBase___Uk1XeU",
  "jd": "UserProfileModal.module__noteTextareaEditing___Uk1XeU",
  "EN": "UserProfileModal.module__noteTextareaNotEditing___Uk1XeU",
  "bs": "UserProfileModal.module__profileContent___Uk1XeU",
  "EM": "UserProfileModal.module__profileContentHeader___Uk1XeU",
  "cI": "UserProfileModal.module__bannerContainer___Uk1XeU",
  "HG": "UserProfileModal.module__bannerMask___Uk1XeU",
  "_e": "UserProfileModal.module__bannerImage___Uk1XeU",
  "N1": "UserProfileModal.module__headerContainer___Uk1XeU",
  "H": "UserProfileModal.module__avatarContainer___Uk1XeU",
  "fc": "UserProfileModal.module__actionButtonsContainer___Uk1XeU",
  "hQ": "UserProfileModal.module__contentContainer___Uk1XeU",
  "sq": "UserProfileModal.module__profileContentWrapper___Uk1XeU",
  "zL": "UserProfileModal.module__scrollerFullHeight___Uk1XeU",
  "jT": "UserProfileModal.module__modalContainer___Uk1XeU",
  "uu": "UserProfileModal.module__actionButtons___Uk1XeU",
  "iA": "UserProfileModal.module__buttonIcon___Uk1XeU",
  "ro": "UserProfileModal.module__menuIcon___Uk1XeU",
  "WB": "UserProfileModal.module__avatarFocusRing___Uk1XeU",
  "VS": "UserProfileModal.module__tabsWrapper___Uk1XeU",
  "OT": "UserProfileModal.module__mutualFriendsList___Uk1XeU",
  "Z8": "UserProfileModal.module__mutualSectionDivider___Uk1XeU",
  "KF": "UserProfileModal.module__mutualFriendItem___Uk1XeU",
  "vu": "UserProfileModal.module__active___Uk1XeU",
  "Qd": "UserProfileModal.module__mutualItemIconFrame___Uk1XeU",
  "D9": "UserProfileModal.module__mutualFriendInfo___Uk1XeU",
  "eV": "UserProfileModal.module__mutualFriendName___Uk1XeU",
  "zD": "UserProfileModal.module__mutualFriendUsername___Uk1XeU",
  "p$": "UserProfileModal.module__emptyState___Uk1XeU",
  "Ny": "UserProfileModal.module__mutualGuildIcon___Uk1XeU",
  "me": "UserProfileModal.module__separator___Uk1XeU",
  "AI": "UserProfileModal.module__emptyStateIcon___Uk1XeU",
};

module.exports = exports;
